@if(feedbackHookRequest?.buttons?.length > 0){
<div class="card mt-md-3 py-4 position-relative">
    <div class="d-flex pt-2 pb-1">
        <div class="anonymity-info-badge"
            [matTooltip]="'Issues and Questions are anonymous, Polls could be anonymous or not and Praises are always on your name' | translate">
            <i class="fa-light fa-mask"></i> choose your feedback type and anonymity 
        </div>
        <div class="name-wrapper avatar">
            <username-icon context="threadInput"
                          [userInfos]="userInfos"></username-icon>
        </div>
        <p class="fs-6 ps-2"> 
            {{'feedback_hook.desc' | translate}}
            <br>{{'feedback_hook.desc2' | translate}}</p>
    </div>
    
    <div class="d-flex justify-content-evenly pt-3 gap-3">
        @if(feedbackHookRequest?.buttons?.indexOf('praise') !== -1){
        <button class="btn btn-default bg-white" (click)="praise()"
                data-cy="user-activity-request-kudos-open">
            <i class="fa-light fa-hands-holding-heart pe-2"></i>{{'feedback_hook.kudos' | translate}}
        </button>
        }
        @if(feedbackHookRequest?.buttons?.indexOf('poll') !== -1){
        <button class="btn btn-default bg-white" (click)="poll()">
            <i class="fa-light fa-square-poll-horizontal pe-2"></i>{{'feedback_hook.poll' | translate}}
        </button>
        }
        @if(feedbackHookRequest?.buttons?.indexOf('issue') !== -1){
        <button class="btn btn-default bg-white" (click)="issue()"
                data-cy="user-activity-request-issue-open">
            <i class="fa-light fa-message-exclamation pe-2"></i>{{'feedback_hook.issue' | translate}}
        </button>
        }
        @if(feedbackHookRequest?.buttons?.indexOf('question') !== -1){
        <button class="btn btn-default bg-white" (click)="question()"
                data-cy="user-activity-request-question-open" >
            <i class="fa-light fa-message-question pe-2"></i>{{'feedback_hook.question' | translate}}
        </button>
        }
    </div>
</div>
}